<template>
  <v-card id="list-dialog" class="com-mb-dialog normal">
    <v-row class="tm-frame com-mb-dialog-header">
      <span class="tm-title com-mb-dialog-title">{{ text.title }}</span>
      <v-tooltip bottom max-width="350px">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="white" class="m-2"
            >help_outline</v-icon
          >
        </template>
        <div>
          {{ this.$store.state.app.config.messageConfig.tmListToolTip }}
        </div>
        <span v-show="tabIndex === 0 || tabIndex === 1">
          <span>
            {{ legendStr.tmStg.tmStgMsg1 }}
            <br />
            {{ legendStr.tmStg.tmStgMsg2 }}
            <br />
          </span>
          <span class="text-flood-occurrence mb-legend-stg-span mb-1">
            {{ legendStr.tmStg.occurrence }}
          </span>
          <br />
          <span class="text-flood-danger mb-legend-stg-span mb-1">
            {{ legendStr.tmStg.danger }}</span
          >
          <br />
          <span class="text-flood-refuge mb-legend-stg-span mb-1">
            {{ legendStr.tmStg.refuge }}
          </span>
          <br />
          <span class="text-flood-warn mb-legend-stg-span mb-1">
            {{ legendStr.tmStg.warn }}
          </span>
        </span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn v-show="!isFull" small icon color="white" @click="expansionWindow">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn v-show="isFull" small icon color="white" @click="reductionWindow">
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-mb-dialog-contents pa-0">
      <v-col class="tm-mb-dialog-frame">
        <v-col class="tm-menu">
          <v-btn-toggle class="tm-btn-box">
            <ul class="tm-menu-table-ul">
              <li
                v-for="(value, key, index) in isReduction ? selectObsDispRed : selectObsDisp"
                :key="key"
                :class="index === Object.keys(isReduction ? selectObsDispRed : selectObsDisp).length-1 ? 'px-1' : 'pl-1'"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="success"
                      class="tm-btn-list"
                      :outlined="!selectObsDisp[key]"
                      @click="changeTabFlag(key)"
                      :disabled="
                        isNoActive(key) ||
                          tabIndex === 2 ||
                          tabIndex === 3 ||
                          tabIndex === 4
                      "
                      v-on="on"
                    >
                      <v-row class="tm-btn-item">
                        <img
                          :src="obsTabMaster[key].url"
                          class="tm-btn-image"
                        />
                      </v-row>
                    </v-btn>
                  </template>
                  <span>{{ obsTabMaster[key].label }}</span>
                </v-tooltip>
              </li>
            </ul>
          </v-btn-toggle>
        </v-col>

        <div class="tm-card-contents">
          <v-col class="tm-menu">
            <v-btn-toggle class="tm-btn-box">
              <ul class="tm-menu-table-ul">
                <li>
                  <v-btn
                    class="tm-tab-btn"
                    :class="{ 'com-btn-on': tabIndex === 0 }"
                    @click="changeTabIndex(0)"
                    >{{ text.tab.twn }}</v-btn
                  >
                </li>
                <li>
                  <v-btn
                    class="tm-tab-btn"
                    :class="{ 'com-btn-on': tabIndex === 1 }"
                    @click="changeTabIndex(1)"
                    >{{ text.tab.rsys }}</v-btn
                  >
                </li>
                <li>
                  <v-btn
                    class="tm-tab-btn"
                    :class="{
                      'com-btn-on': tabIndex === 2,
                      'com-btn-flash': tabIndex !== 2 && typeFlg.tmStgFlg,
                    }"
                    @click="changeTabIndex(2)"
                    >{{ text.tab.ov }}<br />{{ text.tab.stg }}</v-btn
                  >
                </li>
                <li>
                  <v-btn
                    class="tm-tab-btn"
                    :class="{
                      'com-btn-on': tabIndex === 3,
                      'com-btn-flash': tabIndex !== 3 && typeFlg.tmRnFlg,
                    }"
                    @click="changeTabIndex(3)"
                    >{{ text.tab.ov }}<br />{{ text.tab.rn }}</v-btn
                  >
                </li>
                <li>
                  <v-btn
                    class="tm-tab-btn"
                    :class="{
                      'com-btn-on': tabIndex === 4,
                      'com-btn-flash': tabIndex !== 4 && typeFlg.swStgFlg,
                    }"
                    style="white-space: pre-wrap"
                    @click="changeTabIndex(4)"
                    >{{ text.tab.ov }}<br />{{ text.tab.swstg }}</v-btn
                  >
                </li>
                <li>
                  <v-btn
                    rounded
                    depressed
                    outlined
                    icon
                    color="success"
                    class="vc-full-open-btn"
                    small
                    :disabled="!showAllOpenBtn"
                    v-show="
                      tabIndex === 0 && !twnFullOpenFlg && !twnFullOpenReadyFlg
                    "
                    @click="setTwnFullOpenFlg()"
                  >
                    <v-icon size="20px">unfold_more</v-icon>
                  </v-btn>
                  <v-btn
                    rounded
                    depressed
                    outlined
                    loading
                    icon
                    color="success"
                    class="vc-full-open-btn"
                    small
                    v-show="tabIndex === 0 && twnFullOpenReadyFlg"
                    @click="setTwnFullOpenFlg()"
                  >
                    <v-icon size="20px">unfold_less</v-icon>
                  </v-btn>
                  <v-btn
                    rounded
                    depressed
                    outlined
                    icon
                    color="success"
                    class="vc-full-open-btn"
                    small
                    :disabled="!showAllOpenBtn"
                    v-show="
                      (tabIndex === 0 &&
                        twnFullOpenFlg &&
                        !twnFullOpenReadyFlg &&
                        twnFullOpenEndFlg) ||
                        (tabIndex === 0 &&
                          twnFullOpenFlg &&
                          !twnFullOpenReadyFlg &&
                          !twnFullOpenEndFlg)
                    "
                    @click="setTwnFullOpenFlg()"
                  >
                    <v-icon size="20px">unfold_less</v-icon>
                  </v-btn>
                  <v-btn
                    rounded
                    depressed
                    outlined
                    icon
                    color="success"
                    class="vc-full-open-btn"
                    small
                    :disabled="!showAllOpenBtn"
                    v-show="tabIndex === 1 && !rysyFullOpenFlg"
                    @click="setRsysFullOpenFlg()"
                  >
                    <v-icon size="20px">unfold_more</v-icon>
                  </v-btn>
                  <v-btn
                    rounded
                    depressed
                    outlined
                    loading
                    icon
                    color="success"
                    class="vc-full-open-btn"
                    small
                    v-show="tabIndex === 1 && rsysFullOpenReadyFlg"
                    @click="setRsysFullOpenFlg()"
                  >
                    <v-icon size="20px">unfold_less</v-icon>
                  </v-btn>
                  <v-btn
                    rounded
                    depressed
                    outlined
                    icon
                    color="success"
                    class="vc-full-open-btn"
                    small
                    :disabled="!showAllOpenBtn"
                    v-show="
                      (tabIndex === 1 &&
                        rysyFullOpenFlg &&
                        !rsysFullOpenReadyFlg &&
                        rsysFullOpenEndFlg) ||
                        (tabIndex === 1 &&
                          rysyFullOpenFlg &&
                          !rsysFullOpenReadyFlg &&
                          !rsysFullOpenEndFlg)
                    "
                    @click="setRsysFullOpenFlg()"
                  >
                    <v-icon size="20px">unfold_less</v-icon>
                  </v-btn>
                </li>
              </ul>
            </v-btn-toggle>
          </v-col>
          <v-col class="tm-box-list">
            <div v-if="tabIndex === 0">
              <tm-twn-list :selectObsDispPt="selectObsDisp"></tm-twn-list>
            </div>
            <div v-if="tabIndex === 1">
              <tm-rsys-list :selectObsDispPt="selectObsDisp"></tm-rsys-list>
            </div>
            <div v-if="tabIndex === 2">
              <tm-over-list></tm-over-list>
            </div>
            <div v-if="tabIndex === 3">
              <tm-over-rn-list></tm-over-rn-list>
            </div>
            <div v-if="tabIndex === 4">
              <tm-over-swstg-list></tm-over-swstg-list>
            </div>
          </v-col>
        </div>
      </v-col>
    </v-col>
  </v-card>
</template>

<script>
import mixin from "./../../lib/mixin.js";
import TmTwnList from "./TmTwnList.vue";
import TmRsysList from "./TmRsysList.vue";
import TmOverList from "./TmOverList.vue";
import TmOverRnList from "./TmOverRnList.vue";
import TmOverSwstgList from "./TmOverSwstgList.vue";
export default {
  /** タグ名 */
  name: "tm-list-flame",
  mixins: [mixin],
  components: {
    TmTwnList,
    TmRsysList,
    TmOverList,
    TmOverRnList,
    TmOverSwstgList,
  },
  data() {
    return {
      isFull: false,
      obsTabMaster: {
        stgDisp: {
          label: "水位観測",
          url: "/kawabou/img/obs_icons/obs_water.svg",
        },
        swstgDisp: {
          label: this.$store.state.app.config.replaceNameConfig.swstg,
          url: "/kawabou/img/obs_icons/obs_swstg.svg",
        },
        cctvDisp: {
          label: "カメラ",
          url: "/kawabou/img/obs_icons/obs_camera.svg",
        },
        damDisp: {
          label: "ダム",
          url: "/kawabou/img/obs_icons/obs_dam.svg",
        },
        rnDisp: {
          label: "雨量",
          url: "/kawabou/img/obs_icons/obs_rain.svg",
        },
        coastDisp: {
          label: "海岸",
          url: "/kawabou/img/obs_icons/obs_sea.svg",
        },
        snwDisp: {
          label: "積雪",
          url: "/kawabou/img/obs_icons/obs_snow.svg",
        },
        qwtrDisp: {
          label: "水質",
          url: "/kawabou/img/obs_icons/obs_quality.svg",
        },
      },
      /** 文字列リソース */
      text: {
        title: "地図中の観測所一覧",
        tab: {
          ov: "基準値超過",
          stg: "水位観測",
          twn: "市町村別",
          rsys: "河川別",
          rn: "雨量",
          swstg: this.$store.state.app.config.replaceNameConfig.swstgLF,
        },
      },
      befTabIndex: 0,
    };
  },
  created: function() {
    // 観測所表示設定
    this.selectObsDisp = this.$store.state.Telemeter.selectObsDisp[0];
    switch (this.viewContents) {
      case 0:
        break;
      case 1:
        this.selectObsDisp.stgDisp = false;
        this.selectObsDisp.swstgDisp = false;
        this.selectObsDisp.cctvDisp = false;
        this.selectObsDisp.damDisp = false;
        this.selectObsDisp.rnDisp = false;
        this.selectObsDisp.coastDisp = true;
        this.selectObsDisp.snwDisp = true;
        this.selectObsDisp.qwtrDisp = true;
        break;
      case 2:
        this.selectObsDisp.stgDisp = false;
        this.selectObsDisp.swstgDisp = false;
        this.selectObsDisp.cctvDisp = false;
        this.selectObsDisp.damDisp = false;
        this.selectObsDisp.rnDisp = true;
        this.selectObsDisp.coastDisp = false;
        this.selectObsDisp.snwDisp = false;
        this.selectObsDisp.qwtrDisp = false;
        break;
      case 3:
        this.selectObsDisp.stgDisp = false;
        this.selectObsDisp.swstgDisp = false;
        this.selectObsDisp.cctvDisp = false;
        this.selectObsDisp.damDisp = false;
        this.selectObsDisp.rnDisp = false;
        this.selectObsDisp.coastDisp = false;
        this.selectObsDisp.snwDisp = false;
        this.selectObsDisp.qwtrDisp = false;
        break;
    }
    if (global.KWB_MODE === "reduction") {
      // 簡易版の場合は雨量表示はON、海岸、積雪、水質は非表示のためOFF
      this.selectObsDisp.rnDisp = true;
      this.selectObsDisp.coastDisp = false;
      this.selectObsDisp.snwDisp = false;
      this.selectObsDisp.qwtrDisp = false;
    }
  },
  mounted() {
    this.$store.commit("app/setContent", "TmList");
  },
  computed: {
    /** 簡易版の判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    /** 観測所一覧選択タブ */
    tabIndex: {
      get() {
        return this.$store.state.Telemeter.tmListTabIndex;
      },
    },
    /** 観測所一覧全開閉フラグ */
    twnFullOpenFlg: {
      get() {
        return this.$store.state.Telemeter.tmListTwnFullOpenFlg;
      },
    },
    /** 観測所一覧全開閉準備フラグ */
    twnFullOpenReadyFlg: {
      get() {
        return this.$store.state.Telemeter.tmListTwnFullOpenReadyFlg;
      },
    },
    /** 観測所一覧全開閉データ取得完了フラグ */
    twnFullOpenEndFlg: {
      get() {
        return this.$store.state.Telemeter.tmListTwnFullOpenEndFlg;
      },
    },
    /** 観測所一覧水系別全開閉フラグ */
    rysyFullOpenFlg: {
      get() {
        return this.$store.state.Telemeter.tmlistRsysFullOpenFlg;
      },
    },
    /** 観測所一覧水系別全開閉準備フラグ */
    rsysFullOpenReadyFlg: {
      get() {
        return this.$store.state.Telemeter.tmListRsysFullOpenReadyFlg;
      },
    },
    /** 観測所一覧水系別全開閉データ取得完了フラグ */
    rsysFullOpenEndFlg: {
      get() {
        return this.$store.state.Telemeter.tmListRsysFullOpenEndFlg;
      },
    },
    /** 簡易版用表示観測所種別 */
    selectObsDispRed: {
      get() {
        let selectObsDispCopy = structuredClone(this.selectObsDisp);
        delete selectObsDispCopy.coastDisp
        delete selectObsDispCopy.qwtrDisp
        delete selectObsDispCopy.snwDisp
        return selectObsDispCopy
      },
    },
    /** 観測所一覧全開閉ボタン表示 */
    showAllOpenBtn: {
      get() {
        if (this.tabIndex === 0) {
          // 市町村別の場合
          return (
            this.$store.state.map.mapConfig.zoomTmListShowFullOpenBtnByTwn <=
            this.$store.state.map.zoom
          );
        } else {
          // 水系別の場合
          return (
            this.$store.state.map.mapConfig.zoomTmListShowFullOpenBtnByRsys <=
            this.$store.state.map.zoom
          );
        }
      },
    },
    /**
     * 表示範囲のテレメータ超過情報
     */
    tmOverDatas: {
      get() {
        return this.$store.state.Telemeter.tmOverDatas;
      },
    },
    /**
     * 基準値超過テレメータ種別存在フラグ
     */
    typeFlg: {
      get() {
        return this.$store.state.Telemeter.typeFlg;
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
    /** 表示コンテンツ設定 */
    viewContents: {
      get() {
        return this.$store.state.map.viewContents;
      },
    },
  },
  /** メソッド */
  methods: {
    changeTabFlag(key) {
      this.selectObsDisp[key] = !this.selectObsDisp[key];
    },
    changeTabIndex(num) {
      this.$store.commit("Telemeter/setSelectTmListTabIndex", num);
      /** タブ押下でパラメータに反映 */
      let knd = "";
      if (num === 0) {
        knd = "twn";
      } else if (num === 1) {
        knd = "rsys";
      } else if (num === 2) {
        knd = "stg";
      } else if (num === 3) {
        knd = "rn";
      } else if (num === 4) {
        knd = "swstg";
      }
      let setQuery = Object.assign({}, this.$route.query);
      setQuery.knd = knd;
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    /** 画面拡大 */
    expansionWindow() {
      var dlg = document.getElementById("list-dialog");
      dlg.className = "com-mb-dialog large v-card v-sheet theme--light";
      this.isFull = true;
    },
    /** 画面縮小 */
    reductionWindow() {
      var dlg = document.getElementById("list-dialog");
      dlg.className = "com-mb-dialog normal v-card v-sheet theme--light";
      this.isFull = false;
    },
    /** 画面を閉じる */
    closeDlg() {
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
      // 基準値超過タブフラグを0にする
      this.$store.commit("Telemeter/setTmOverListFlg", 0);
    },
    setTwnFullOpenFlg() {
      let flg;
      if (this.twnFullOpenFlg) {
        flg = false;
        this.$store.commit("Telemeter/setTmListTwnFullOpenEndFlg", flg);
      } else {
        flg = true;
      }
      this.$store.commit("Telemeter/setTmListTwnFullOpenFlg", flg);
    },
    setRsysFullOpenFlg() {
      let flg;
      if (this.rysyFullOpenFlg) {
        flg = false;
        this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", flg);
      } else {
        flg = true;
      }
      this.$store.commit("Telemeter/setTmListRsysFullOpenFlg", flg);
    },
    isNoActive(key) {
      if (
        global.KWB_MODE === "reduction" &&
        (key === "coastDisp" || key === "snwDisp" || key === "qwtrDisp")
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    tabIndex() {
      //  観測所一覧選択タブが変更された場合、全展開フラグをOFFにする。
      if (this.tabIndex != this.befTabIndex) {
        this.$log.debug(
          "[TmListFrame] this.tabIndex !== this.befTabIndex:" +
            (this.tabIndex != this.befTabIndex)
        );
        this.befTabIndex = this.tabIndex;

        this.$store.commit("Telemeter/setTmListTwnFullOpenFlg", false);
        this.$store.commit("Telemeter/setTmListTwnFullOpenReadyFlg", false);
        this.$store.commit("Telemeter/setTmListTwnFullOpenEndFlg", false);

        this.$store.commit("Telemeter/setTmListRsysFullOpenFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenReadyFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../scss/_media_query.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 60%;
    top: 84px;
  }
  .large {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 40%;
    bottom: 4px;
  }
  .large {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
}

#list-dialog {
  right: 4px;
  overflow: hidden;
}

.tm-tab-btn {
  padding-left: 0 0px;
  height: 40px !important;
  max-width: 20px;
  font-size: 0.5rem;
  min-width: 55px !important;
}
</style>
